{
  "mail.action.archive": "Archive",
  "mail.action.failed": "Mail action failed",
  "mail.action.moveToInbox": "Move to Inbox",
  "mail.action.notSpam": "Not spam",
  "mail.action.read": "Mark read",
  "mail.action.restore": "Restore",
  "mail.action.restoredMany": "{count} conversations moved to the Inbox",
  "mail.action.spam": "Spam",
  "mail.action.star": "Star",
  "mail.action.trash": "Delete",
  "mail.action.unread": "Mark unread",
  "mail.admin.connect": "Connect",
  "mail.admin.connected": "Connected",
  "mail.admin.desk": "Service desk",
  "mail.admin.deskAssignee": "Default assignee",
  "mail.admin.deskAutoTicket": "Auto-ticket",
  "mail.admin.deskTeam": "Default team",
  "mail.admin.disconnect": "Disconnect",
  "mail.admin.disconnectMail": "Disconnect mail",
  "mail.admin.domainRemove": "Remove {domain}",
  "mail.admin.grants": "grants",
  "mail.admin.kind.personal": "Personal",
  "mail.admin.kind.shared": "Shared",
  "mail.admin.kind.tenant": "Tenant",
  "mail.admin.notConnected": "Not connected",
  "mail.admin.openGoogle": "Open Google Workspace integration",
  "mail.admin.provision": "Provision members",
  "mail.admin.provisionApply": "Apply provisioning?",
  "mail.admin.remove": "Remove",
  "mail.admin.sharedPending": "Adding shared inboxes arrives with the mail server update.",
  "mail.admin.simulated": "Simulated",
  "mail.admin.simulatedHint": "Demo tenant. No provider is contacted and every mailbox holds seeded sample data.",
  "mail.admin.status.active": "Live",
  "mail.admin.status.connecting": "Connecting",
  "mail.admin.status.disabled": "Disabled",
  "mail.admin.status.error": "Error",
  "mail.admin.status.reauth": "Needs reconnect",
  "mail.admin.status.unknown": "Unknown",
  "mail.admin.tenant.done": "Done",
  "mail.admin.tenant.failed": "Action failed",
  "mail.admin.tenant.pending": "This action needs the mail server update. Use the steps above for now.",
  "mail.admin.tenant.provisionDone": "Members provisioned",
  "mail.admin.tenant.provisionDryDone": "Provisioning dry run finished",
  "mail.admin.tenant.testFailed": "Mailbox access test failed",
  "mail.admin.tenant.testOk": "Mailbox access verified",
  "mail.admin.test": "Test mailbox access",
  "mail.admin.toast.disconnectFailed": "Couldn't disconnect the account",
  "mail.admin.toast.disconnected": "Account disconnected",
  "mail.admin.toast.notReady": "The workspace is not ready yet",
  "mail.admin.toast.saveFailed": "Couldn't save mail policy",
  "mail.answer.earlier": "Earlier",
  "mail.answer.noMatch": "No mail matches.",
  "mail.answer.unread": "Unread · {count}",
  "mail.attachment.downloadFailed": "Could not download the attachment",
  "mail.attachment.one": "Attachment",
  "mail.attachment.save": "Save to Files",
  "mail.attachment.saveFailed": "Could not save to Files",
  "mail.attachment.saved": "Saved to Files",
  "mail.attachment.unavailable": "Attachment download is not available yet",
  "mail.banner.backfill": "Syncing your mail · {p}",
  "mail.banner.reconnect": "Reconnect {address} to keep mail in sync",
  "mail.banner.reconnectAction": "Reconnect",
  "mail.body.frameTitle": "Email message",
  "mail.body.hideQuoted": "Hide quoted text",
  "mail.body.imagesBlocked": "Remote images are blocked ({n})",
  "mail.body.loadFailed": "Could not load this message",
  "mail.body.loadImages": "Load images",
  "mail.body.loading": "Loading message…",
  "mail.body.showQuoted": "Show quoted text",
  "mail.compose.attach": "Attach files",
  "mail.compose.attachFailed": "Could not attach",
  "mail.compose.attachTooLarge": "File is too large",
  "mail.compose.attachTooMany": "Too many attachments",
  "mail.compose.bcc": "Bcc",
  "mail.compose.bodyAria": "Message body",
  "mail.compose.cc": "Cc",
  "mail.compose.ccToggle": "Cc/Bcc",
  "mail.compose.discard": "Discard draft",
  "mail.compose.from": "From",
  "mail.compose.fwdIntro": "---------- Forwarded message ----------",
  "mail.compose.mondayAm": "Monday morning",
  "mail.compose.new": "Compose",
  "mail.compose.noRecipients": "Add at least one recipient",
  "mail.compose.quoteIntro": "On {date}, {who} wrote:",
  "mail.compose.saved": "Saved",
  "mail.compose.saving": "Saving…",
  "mail.compose.schedule": "Schedule send",
  "mail.compose.scheduleCustom": "Custom time",
  "mail.compose.scheduleGo": "Schedule",
  "mail.compose.scheduleTitle": "Pick a time",
  "mail.compose.scheduled": "Send scheduled",
  "mail.compose.send": "Send",
  "mail.compose.sendFailed": "Could not send",
  "mail.compose.sending": "Sending…",
  "mail.compose.subject": "Subject",
  "mail.compose.title": "New message",
  "mail.compose.to": "To",
  "mail.compose.tomorrowAm": "Tomorrow morning",
  "mail.compose.tomorrowPm": "Tomorrow afternoon",
  "mail.compose.undoFailed": "Could not undo",
  "mail.compose.undoHint": "Click to undo",
  "mail.compose.undoLate": "Already sent",
  "mail.confirm.archiveMany.button": "Archive",
  "mail.confirm.archiveMany.message": "The selected conversations leave this list and move to Archive.",
  "mail.confirm.archiveMany.title": "Archive {count} conversations?",
  "mail.confirm.discard.button": "Discard",
  "mail.confirm.discard.message": "The draft and its attachments are deleted. This can’t be undone.",
  "mail.confirm.discard.title": "Discard the draft “{subject}”?",
  "mail.confirm.discard.titleUntitled": "Discard this draft?",
  "mail.confirm.disconnect.message": "Your mail stays with your mail provider. Drafts and scheduled sends saved here are deleted. You can connect the mailbox again later.",
  "mail.confirm.disconnect.title": "Disconnect {address}?",
  "mail.confirm.disconnectDemo.message": "Its demo mail and attachments are deleted for good. This can’t be undone.",
  "mail.confirm.disconnectDemo.title": "Delete the demo mailbox {address}?",
  "mail.confirm.domain.message": "People can no longer connect a new personal mailbox with an address on {domain}. Mailboxes already connected stay connected.",
  "mail.confirm.domain.openMessage": "It is the last domain on the list, and an empty list means no restriction: a personal mailbox on any domain can connect.",
  "mail.confirm.domain.title": "Remove {domain} from allowed domains?",
  "mail.confirm.member.message": "The mailbox stops syncing here, and the drafts and scheduled sends saved here are deleted. Mail stays with the mail provider, and the mailbox can be connected again.",
  "mail.confirm.shared.message": "Everyone loses access to it here, and the drafts and scheduled sends saved here are deleted. Mail stays with the mail provider.",
  "mail.confirm.shared.title": "Remove the shared mailbox {address}?",
  "mail.confirm.spamMany.button": "Move to Spam",
  "mail.confirm.spamMany.message": "The selected conversations leave this list and move to Spam.",
  "mail.confirm.spamMany.title": "Move {count} conversations to Spam?",
  "mail.confirm.tenant.message": "Members’ company mailboxes stop syncing here. Mail stays with {provider}, and the calendar connection stays. You can connect mail again later.",
  "mail.confirm.tenant.title": "Disconnect {provider} mail for the whole workspace?",
  "mail.confirm.tenantDemo.message": "Every demo mailbox, with its mail and attachments, is deleted for good. This can’t be undone.",
  "mail.confirm.tenantDemo.title": "Delete the demo {provider} mail?",
  "mail.confirm.trash.message": "The conversation moves to Trash. Your mail provider keeps it there until it empties Trash.",
  "mail.confirm.trash.title": "Delete “{subject}”?",
  "mail.confirm.trashMany.message": "The selected conversations move to Trash. Your mail provider keeps them there until it empties Trash.",
  "mail.confirm.trashMany.title": "Delete {count} conversations?",
  "mail.drawer.open": "Open Mail",
  "mail.drawer.title": "Mail",
  "mail.empty.body": "Connect a Google or Microsoft mailbox to read and send email here. A workspace admin can also connect a Google Workspace or Microsoft 365 tenant for everyone.",
  "mail.empty.heading": "Mail is not connected yet",
  "mail.error.providerNotConfigured": "{provider} mail is not available yet. Contact support.",
  "mail.error.providerNotConfiguredGeneric": "This mail provider is not available yet. Contact support.",
  "mail.error.pushNotConfigured": "Instant mail updates are not available. Mail still syncs on a schedule.",
  "mail.error.signingNotConfigured": "Mail cannot create a secure link right now. Contact support.",
  "mail.error.tokenVaultNotConfigured": "Mail cannot open or save mailbox sign-ins right now. Contact support.",
  "mail.filter.attachments": "Has files",
  "mail.filter.starred": "Starred",
  "mail.filter.unread": "Unread",
  "mail.folder.archive": "Archive",
  "mail.folder.drafts": "Drafts",
  "mail.folder.inbox": "Inbox",
  "mail.folder.sent": "Sent",
  "mail.folder.spam": "Spam",
  "mail.folder.starred": "Starred",
  "mail.folder.trash": "Trash",
  "mail.integrate.calendar": "Add to calendar",
  "mail.integrate.eventCreated": "Added to calendar",
  "mail.integrate.eventFailed": "Could not add to calendar",
  "mail.integrate.menu": "More actions",
  "mail.integrate.noChannels": "No channels yet — open Chat first",
  "mail.integrate.searchChannels": "Search channels",
  "mail.integrate.share": "Share to chat",
  "mail.integrate.shareFailed": "Could not share to chat",
  "mail.integrate.shared": "Shared to chat",
  "mail.integrate.ticket": "Create ticket",
  "mail.integrate.ticketCreated": "Ticket created",
  "mail.integrate.ticketFailed": "Could not create the ticket",
  "mail.invite.accept": "Accept",
  "mail.invite.cancelled": "Event cancelled",
  "mail.invite.decline": "Decline",
  "mail.invite.invitation": "Calendar invitation",
  "mail.invite.organizer": "Organized by {name}",
  "mail.invite.replied": "Invitation response",
  "mail.invite.rsvpFailed": "RSVP failed",
  "mail.invite.status.accepted": "You accepted this invitation",
  "mail.invite.status.declined": "You declined this invitation",
  "mail.invite.status.tentative": "You responded maybe",
  "mail.invite.tentative": "Maybe",
  "mail.list.emptyFolder": "Nothing here",
  "mail.list.loadFailed": "Could not load this folder",
  "mail.list.loadOlder": "Load older",
  "mail.list.loading": "Loading…",
  "mail.list.me": "me",
  "mail.list.noSubject": "(no subject)",
  "mail.list.retry": "Retry",
  "mail.list.searchPlaceholder": "Search mail",
  "mail.list.select": "Select",
  "mail.page.title": "Mail",
  "mail.settings.action.disconnect": "Disconnect",
  "mail.settings.action.reconnect": "Reconnect",
  "mail.settings.action.save": "Save",
  "mail.settings.description": "Mailboxes connected to this workspace.",
  "mail.settings.disconnected": "Mailbox disconnected",
  "mail.settings.field.sendAs": "Default send-as",
  "mail.settings.field.signature": "Signature",
  "mail.settings.kind.personal": "Personal",
  "mail.settings.kind.shared": "Shared",
  "mail.settings.kind.tenant": "Company",
  "mail.settings.listFailed": "Your mailboxes could not be loaded.",
  "mail.settings.saved": "Mail settings saved",
  "mail.settings.simulated": "Simulated",
  "mail.settings.status.active": "Live",
  "mail.settings.status.disabled": "Disabled",
  "mail.settings.status.reauth": "Needs reconnect",
  "mail.settings.status.syncing": "Syncing",
  "mail.settings.title": "Mail",
  "mail.setup.admin.action": "Set up mail",
  "mail.setup.admin.steps": "Admin setup",
  "mail.setup.askAdmin.action": "Notify an admin",
  "mail.setup.askAdmin.already": "An admin was notified in the last 24 hours.",
  "mail.setup.askAdmin.body": "An admin connects Google Workspace or Microsoft 365 once, and every member gets a mailbox.",
  "mail.setup.askAdmin.failed": "The admins could not be notified.",
  "mail.setup.askAdmin.notified": "An admin was notified.",
  "mail.setup.askAdmin.title": "Mail is not set up for this workspace",
  "mail.setup.askAdmin.youAreAdmin": "You administer mail for this organisation. Open the admin page to set it up.",
  "mail.setup.connect.action": "Continue with {provider}",
  "mail.setup.connect.blockedPlatform": "This provider is not configured on this server yet.",
  "mail.setup.connect.body": "Sign in with Google or Microsoft. Symbols reads and sends on your own account and never stores your password.",
  "mail.setup.connect.pending": "Mailbox sign-in is not available in this build yet. An admin can connect Google Workspace or Microsoft 365 for everyone.",
  "mail.setup.connect.title": "Connect a mailbox to send email",
  "mail.setup.error.retry": "Try again",
  "mail.setup.error.title": "Mail setup could not be read",
  "mail.setup.googleConnect.connected": "Google Workspace is connected. The service-account key on the integration is what Mail impersonates members with.",
  "mail.setup.googleConnect.connectedDomain": "Google Workspace is connected for {domain}. The service-account key on the integration is what Mail impersonates members with.",
  "mail.setup.googleConnect.instructions": "Open Admin → Integrations → Google Workspace and add the service-account key JSON for your domain. Set the admin impersonation email so Mail can test access.",
  "mail.setup.googleConnect.title": "Connect Google Workspace",
  "mail.setup.googleDelegation.instructions": "In Google Admin go to Security → Access and data control → API controls → Manage domain-wide delegation. Add a new client with the client ID of your service account (the client_id field in the key file you added to the Google Workspace integration) and paste the scope list below as one comma-separated line. If that client is already listed, edit it and add these scopes to the ones it has.",
  "mail.setup.googleDelegation.scopesMissing": "In Google Admin go to Security → Access and data control → API controls → Manage domain-wide delegation. Contact support to get the mail scope list. Then add a new client with the client ID of your service account (the client_id field in the key file you added to the Google Workspace integration) and that scope list.",
  "mail.setup.googleDelegation.title": "Authorise domain-wide delegation for mail",
  "mail.setup.googleTest.instructions": "Back in Admin → Mail, run \"Test mailbox access\" (reads the admin mailbox and one directory user), then \"Provision members\" to create a mailbox for every member the directory matches.",
  "mail.setup.googleTest.title": "Test and provision mailboxes",
  "mail.setup.link.action": "Link my mailbox",
  "mail.setup.link.body": "Your organisation connected a mail provider, but no mailbox is linked to you yet. Link it, or ask an admin to check the directory match.",
  "mail.setup.link.failed": "Your mailbox could not be linked.",
  "mail.setup.link.linked": "Your mailbox is linked.",
  "mail.setup.link.pending": "Mailbox linking is not switched on yet.",
  "mail.setup.link.title": "Your mailbox is not linked yet",
  "mail.setup.loading": "Checking your mail setup…",
  "mail.setup.microsoftConsent.appMissing": "Sign in as a Microsoft 365 global administrator and approve the Symbols Mail application for your tenant. The callback records your tenant id on the integration. The Symbols Mail application is not available for your workspace yet. Contact support to enable it before you grant consent.",
  "mail.setup.microsoftConsent.connected": "Microsoft 365 is connected (tenant {tenantId}). Re-run consent only if the application permissions change.",
  "mail.setup.microsoftConsent.instructions": "Sign in as a Microsoft 365 global administrator and approve the Symbols Mail application for your tenant. The callback records your tenant id on the integration.",
  "mail.setup.microsoftConsent.title": "Grant admin consent",
  "mail.setup.microsoftPolicy.appMissing": "Application permissions cover every mailbox in the tenant. In Exchange Online PowerShell, scope the application to a mail-enabled security group that holds the members who use Mail. The command appears here once the Symbols Mail application is available for your workspace.",
  "mail.setup.microsoftPolicy.instructions": "Application permissions cover every mailbox in the tenant. In Exchange Online PowerShell, scope the application to a mail-enabled security group that holds the members who use Mail.",
  "mail.setup.microsoftPolicy.title": "Limit mailbox access (recommended)",
  "mail.setup.microsoftTest.instructions": "Back in Admin → Mail, run \"Test\" (acquires a tenant token and reads one user plus the admin inbox), then \"Provision members\".",
  "mail.setup.microsoftTest.title": "Test and provision mailboxes",
  "mail.setup.ready.action": "Write a message",
  "mail.setup.ready.body": "You can write and send email from this workspace.",
  "mail.setup.ready.title": "Mail is ready",
  "mail.setup.reauth.action": "Reconnect",
  "mail.setup.reauth.body": "The connection to this mailbox expired. Reconnect it to read and send again.",
  "mail.setup.reauth.title": "Reconnect your mailbox to send",
  "mail.setup.step.copied": "Copied",
  "mail.setup.step.copy": "Copy",
  "mail.setup.step.copyFailed": "Copy failed",
  "mail.sidebar.accounts": "Accounts",
  "mail.sidebar.allInboxes": "All inboxes",
  "mail.sidebar.folders": "Folders",
  "mail.sidebar.labels": "Labels",
  "mail.sidebar.needsAttention": "Needs attention",
  "mail.thread.forward": "Forward",
  "mail.thread.loadFailed": "Could not open this conversation",
  "mail.thread.loading": "Opening…",
  "mail.thread.pickOne": "Pick a conversation to read it here",
  "mail.thread.reply": "Reply",
  "mail.thread.replyAll": "Reply all",
  "mail.thread.to": "to"
}
